import {
  formatDeleteHeaders,
  formatGetHeaders,
  formatMultipartHeaders,
  formatPostHeaders,
  formatPutHeaders,
} from '@configurations/api-configuration';
import { PmoGateway } from '@scenario/gateways/pmo.gateway';
import { Pmo } from '@scenario/models/pmo.model';
import { environment } from '../../../../../environments/environment';
import { HttpStatusCode } from '@angular/common/http';

export class ApiPmoGateway implements PmoGateway {
  private readonly pmoApi = `${environment.backend_url}/api/v1/pmo`;

  async retrieveAll(): Promise<Pmo[]> {
    const response = await fetch(this.pmoApi, await formatGetHeaders());
    if (!response.ok) {
      throw new Error(`Failed to retrieve PMOs: ${response.status}`);
    }
    return response.json();
  }

  async create(pmo: Pmo): Promise<Pmo> {
    const response = await fetch(this.pmoApi, await formatPostHeaders(pmo));
    if (response.status !== HttpStatusCode.Created) {
      throw new Error(`Failed to create PMO: ${response.status}`);
    }
    return response.json();
  }

  async update(pmo: Pmo): Promise<Pmo> {
    const response = await fetch(`${this.pmoApi}/${pmo.id}`, await formatPutHeaders(pmo));
    if (!response.ok) {
      throw new Error(`Failed to update PMO: ${response.status}`);
    }
    return response.json();
  }

  async delete(id: number): Promise<void> {
    const response = await fetch(`${this.pmoApi}/${id}`, await formatDeleteHeaders());
    if (!response.ok) {
      throw new Error(`Failed to delete PMO: ${response.status}`);
    }
  }

  async uploadFile(file: File,): Promise<{ fileUrl: string; originalFileName: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await fetch(`${this.pmoApi}/upload`, await formatMultipartHeaders(formData));
    if (response.status !== HttpStatusCode.Created) {
      throw new Error(`Failed to upload PMO file: ${response.status}`);
    }
    return response.json();
  }

  async retrieveReleases(): Promise<string[]> {
    const response = await fetch(`${this.pmoApi}/releases`, await formatGetHeaders());
    if (!response.ok) {
      throw new Error(`Failed to retrieve PMO releases: ${response.status}`);
    }
    return response.json();
  }
}
